import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidePanelContextType {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    width: number;
    setWidth: (width: number) => void;
}

const SidePanelContext = createContext<SidePanelContextType | undefined>(undefined);

export const SidePanelProvider = ({ children }: { children: ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [width, setWidth] = useState(0);

    return (
        <SidePanelContext.Provider value={{ isOpen, setIsOpen, width, setWidth }}>
            {children}
        </SidePanelContext.Provider>
    );
};

export const useSidePanel = () => {
    const context = useContext(SidePanelContext);
    if (context === undefined) {
        throw new Error('useSidePanel must be used within a SidePanelProvider');
    }
    return context;
};
